import { useMemo, useState } from 'react';

import { useSale } from '../../../../hooks/sale/useSale';
import POSSelectedProductCard from './POSSelectedProductCard';
import POSEmptySelectedProducts from './POSEmptySelectedProducts';
import SearchField from '../../../Header/SearchInput/SearchField';

const POSSelectedProducts = () => {
  const { form } = useSale();

  const [search, setSearch] = useState('');

  const products = form?.products || [];

  const filteredProducts = useMemo(() => {
    const term = search.trim().toLowerCase();

    if (!term) return products;

    return products.filter((product) =>
      [product.productName, product.productCode]
        .filter(Boolean)
        .some((value) => String(value).toLowerCase().includes(term))
    );
  }, [products, search]);

  if (products.length === 0) {
    return <POSEmptySelectedProducts />;
  }

  return (
    <div className="flex flex-col">
      <SearchField
        value={search}
        placeholder="Buscar producto agregado..."
        onChange={setSearch}
      />

      {filteredProducts.map((product) => (
        <POSSelectedProductCard key={product.id} product={product} />
      ))}
    </div>
  );
};

export default POSSelectedProducts;
